
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dntIc", function(module, exports) {

$parcel$export(module.exports, "CalendarIcon", () => $396dbc28afd32363$export$5fda1783bb83f57b);

var $gwFzn = parcelRequire("gwFzn");

var $8DN9t = parcelRequire("8DN9t");

var $luv00 = parcelRequire("luv00");
const $396dbc28afd32363$export$5fda1783bb83f57b = ({ isSelected: isSelected })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
        spacing: "spacious",
        color: isSelected ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon, #44546F)",
        ...ssrPlaceholderIdProp,
        label: "",
        testId: "space-nav-calendar-icon-temp-do-not-use"
    });
};

});


//# sourceMappingURL=CalendarIcon.118f28f5.js.map
